import Icon from '../components/Icon.vue'

Icon.register({
  'hard-hat': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 288v64h-448v-64c0-80.3 49.3-148.9 119.2-177.6l40.8 81.6v-112c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v112l40.8-81.6c69.9 28.7 119.2 97.4 119.2 177.6zM496 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hard-hat.js
// module id = 1440
// module chunks = 0